module.exports = __webpack_public_path__ + "img/vue-logoold.4f51c764.png";